import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import * as ACTIONTYPES from './actionTypes';
import IntlConfigActionTypes from '../Redux/actionTypes';
/**
 * IntlConfig Reducer.
 * Maintains the 'UAIntlConfig' portion of the store.
 */

function intlConfigReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    locales: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONTYPES.LOAD_INTLCONFIG:
    case ACTIONTYPES.CHANGE_INTLCONFIG:
      return _Object$assign({}, state, action.intlConfig);

    case IntlConfigActionTypes.RESET_STORE_AFTER_LOGOUT:
      {
        // The complete state has been cleared on logout, but we want to re-instate
        // the basic configuration for the next user.
        return _Object$assign({}, state, action.initialConfig.intlConfig);
      }

    default:
      return state;
  }
} // eslint-disable-next-line import/prefer-default-export


export { intlConfigReducer };